export default __webpack_public_path__ + "static/media/020-express.8c895183.svg";